import Api from "../services/Api";

// Method to get report Delivery Schedule
export const getDeliveryScheduleHist = async (year, week, supplierId, warehouseCodes, buyer) => {
  try {
    const params = new URLSearchParams();
    params.append("year", year.toString());
    params.append("week", week.toString());

    warehouseCodes?.filter(Boolean)
      .forEach((c) => params.append("warehouseCode", c));

    if (supplierId) params.append("supplierId", supplierId.toString());
    if (buyer) params.append("buyer", buyer);
    const res = await Api.get("/deliverySchedule/hist", params);
    if (!res.status) throw new Error(res.payload ?? res.message);
    return res.payload;
  } catch (error) {
    console.log(error);
    throw new Error(error.message, { cause: error });
  }
};

// Method to get list of suppliers involved in Delivery Schedule for given week
export const getDeliveryScheduleSuppliers = async (year, week, notified, confirmed) => {
  try {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('week', week);
    if (notified) params.append('notified', notified);
    if (confirmed) params.append('confirmed', confirmed);

    const response = await Api.get("/deliverySchedule/suppliers", params);
    console.log({ response });
    if (response.status) {
      return response.payload;
    } else {
      console.error(response.payload ? response.payload : response.message);
      throw new Error(response.payload ? response.payload : response.message);
    }
  } catch (error) {
    console.log(error);
    throw new Error(error.message, { cause: error });
  }
};


